import type { PackageFragment } from '@ecomm/partners-data/lib/packageSchema'
import * as O from 'fp-ts/lib/Option'
import * as A from 'fp-ts/lib/ReadonlyArray'
import { pipe } from 'fp-ts/lib/function'

/**
 * Will return a relative url using the first package's slug in the array. Useful if you
 * need to change the url for "Shop Now" CTA buttons in partner pages. If there are no
 * packages, it returns empty string.
 */
export const getFirstPackageUrl = (packagesData: readonly PackageFragment[]) =>
  pipe(
    packagesData,
    A.head,
    O.map(pkg => (pkg.slug.startsWith('/') ? pkg.slug : `/${pkg.slug}`)),
    O.getOrElse(() => '')
  )
